import React, { useEffect, useState } from "react";
import { CircularIndeterminate, FormButton } from "components";
import QRCode from "react-qr-code";

export default function QrModal({ hotel, closeModal }) {
    const [qr, setQr] = useState();

    useEffect(() => {
        if (!hotel?.SFHotelId) return;
        const codigoQR = `SFHOTEL!${hotel.SFHotelId}!SFHOTEL`;
        setQr(codigoQR);
    }, [hotel]);

    const imprimirElemento = (elemento) => {
        const ventana = window.open("", "PRINT");
        ventana.document.write(`<html><head><title>${hotel.SFHotelNombre}</title>`);
        ventana.document.write(
            "<style>*{-webkit-print-color-adjust: exact;print-color-adjust: exact;}@page{margin: 0;}body{margin: 0; padding: 0; display: flex; flex-direction: column; align-items: center; justify-content: start; height: 100%; background-color: #f5f0e9}</style>"
        );
        ventana.document.write("</head><body >");
        ventana.document.write(elemento.innerHTML);
        ventana.document.write("</body></html>");
        ventana.document.close();
        ventana.focus();
        ventana.print();
        ventana.close();
        closeModal();
        return true;
    };

    const printQr = () => {
        const element = document.getElementById("containerQr");
        const top = document.getElementById("containerTop");
        top.style.display = "flex";
        top.style.backgroundColor = "#4a4f5a";

        const green = document.getElementById("greenBg");
        green.style.display = "flex";

        const containerQr = document.getElementById("contQr");
        containerQr.style.padding = "42px";
        containerQr.style.backgroundColor = "#fff";
        containerQr.style.borderRadius = "42px";

        const textScan = document.getElementById("textScan");
        textScan.style.display = "flex";

        const bottom = document.getElementById("containerBottom");
        bottom.style.display = "flex";

        bottom.innerHTML = `
        <div style="display:flex; flex-direction:column; gap:16px; padding: 16px 24px;">
            ${["Abrí la App", "Escaneá el código QR", "¡Listo!"].map((text, i) => `
                <div style="display:flex; align-items:center; gap:12px;">
                    <div style="
                        min-width:48px; height:48px;
                        background-color:#FF6600;
                        border-radius:50%;
                        display:flex; align-items:center; justify-content:center;
                        color:#fff; font-weight:bold; font-size:30px;
                        font-family: Lato, sans-serif;
                    ">${i + 1}</div>
                    <span style="font-size:32px; font-weight: 400; font-family: Lato, sans-serif; color: #474f5e; ${i === 2 ? "font-weight:bold;" : ""}">${text}</span>
                </div>
            `).join("")}
        </div>
    `;

        const qrElement = document.getElementById("qr");
        qrElement.style.width = "300px";
        qrElement.style.height = "300px";

        imprimirElemento(element);
    };

    return (
        <div style={{ padding: "0 3rem 1rem" }}>
            <div>
                <div
                    id="containerQr"
                    style={{
                        display: "flex",
                        justifyContent: "start",
                        alignItems: "center",
                        flexDirection: "column",
                        width: "100%",
                        height: "100%",
                    }}
                >
                    <div
                        id="containerTop"
                        style={{
                            fontFamily: "Lato, sans-serif",
                            backgroundColor: "#06132F",
                            minHeight: "20px",
                            width: "100%",
                            padding: "32px 20px",
                            display: "none",
                            gap: "80px",
                            justifyContent: "space-around",
                            alignItems: "baseline",
                            position: "relative",
                            zIndex: "2",
                        }}
                    >
                        <h2
                            style={{
                                margin: "0",
                                fontSize: "48px",
                                color: "#FFFFFF",
                            }}
                        >
                            {hotel.SFHotelNombre}
                        </h2>
                    </div>
                    <div
                        id="greenBg"
                        style={{
                            width: "100%",
                            height: "500px",
                            position: "absolute",
                            top: "0",
                            zIndex: "1",
                            backgroundColor: "#FF6909",
                            display: "none",
                            borderRadius: "80px 0px",
                        }}
                    />
                    <div
                        style={{
                            width: "100%",
                            display: "flex",
                            flexDirection: "column",
                            padding: "16px",
                            paddingTop: "38px",
                        }}
                    >
                        <div
                            id="textScan"
                            style={{
                                fontFamily: "Lato, sans-serif",
                                color: "#FFFFFF",
                                position: "relative",
                                zIndex: "2",
                                display: "none",
                                flexDirection: "column",
                                gap: "8px",
                                marginLeft: "32px",
                                marginBlock: "56px 24px",
                            }}
                        >
                            <h4 style={{ fontSize: "48px", margin: "0" }}>
                                Escaneá el QR
                            </h4>
                            <p style={{ fontSize: "32px", margin: "0" }}> </p>
                        </div>
                        {qr ? (
                            <div
                                id="contQr"
                                style={{
                                    width: "fit-content",
                                    margin: "auto",
                                    display: "flex",
                                    justifyContent: "center",
                                    position: "relative",
                                    zIndex: "2",
                                }}
                            >
                                <QRCode
                                    value={qr}
                                    id="qr"
                                    style={{ width: "300px", height: "300px" }}
                                />
                            </div>
                        ) : (
                            <CircularIndeterminate />
                        )}
                    </div>
                    <div
                        id="containerBottom"
                        style={{
                            minHeight: "20px",
                            width: "100%",
                            paddingBlock: "32px",
                            display: "none",
                            justifyContent: "center",
                            flexDirection: "column",
                            alignItems: "start",
                            gap: "16px",
                            maxWidth: "575px",
                        }}
                    >
                        {/* <div
                            style={{
                                display: "flex",
                                gap: "16px",
                                fontSize: "32px",
                                fontFamily: "Lato, sans-serif",
                                alignItems: "center",
                                width: "100%",
                                borderBottom: "2px solid #2B3E4C",
                                paddingBottom: "10px",
                            }}
                        >
                            <p style={{ margin: "0", height: "fit-content", flex: "10" }}>
                                Abrí la App
                            </p>
                        </div>
                        <div
                            style={{
                                display: "flex",
                                gap: "16px",
                                fontSize: "32px",
                                fontFamily: "Lato, sans-serif",
                                alignItems: "center",
                                borderBottom: "2px solid #2B3E4C",
                                paddingBottom: "10px",
                            }}
                        >
                            <p style={{ margin: "0", height: "fit-content", flex: "10" }}>
                                Escaneá el código QR
                            </p>
                        </div>
                        <div
                            style={{
                                display: "flex",
                                gap: "16px",
                                fontSize: "32px",
                                fontFamily: "Lato, sans-serif",
                                alignItems: "center",
                                width: "100%",
                            }}
                        >
                            <p style={{ margin: "0", height: "fit-content", flex: "10" }}>
                                <b>¡Listo!</b>
                            </p>
                        </div> */}
                    </div>
                </div>
            </div>
            <FormButton
                onClick={printQr}
                newFormData={{ button: "Imprimir" }}
                onCloseModal={closeModal}
            />
        </div>
    );
}
